export default __webpack_public_path__ + "static/media/home.5b322d92.svg";